import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import ListingsPage from "./pages/ListingsPage";
import ListingDetailPage from "./pages/ListingDetailPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import NewListingPage from "./pages/NewListingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import InvestorPage from "./pages/InvestorPage";
import FAQPage from "./pages/FAQPage";
import PoliciesPage from "./pages/PoliciesPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdvertiserProfilePage from "./pages/AdvertiserProfilePage";
import FavoritesPage from "./pages/FavoritesPage";

// Admin Pages
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function App() {
    return (
        <AuthProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/listings" element={<ListingsPage />} />
                        <Route path="/listing/:id" element={<ListingDetailPage />} />
                        <Route path="/advertiser/login" element={<LoginPage />} />
                        <Route path="/advertiser/register" element={<RegisterPage />} />
                        <Route path="/advertiser/:advertiserId" element={<AdvertiserProfilePage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/dashboard/new-listing" element={<NewListingPage />} />
                        <Route path="/dashboard/edit-listing/:id" element={<NewListingPage />} />
                        <Route path="/favorites" element={<FavoritesPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/investor" element={<InvestorPage />} />
                        <Route path="/faq" element={<FAQPage />} />
                        <Route path="/policies" element={<PoliciesPage />} />
                        
                        {/* Admin Routes */}
                        <Route path="/admin" element={<AdminLoginPage />} />
                        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </div>
        </AuthProvider>
    );
}

export default App;
